__turbopack_context__.v({
  "container": "ModelHeader-module__flUtYW__container",
  "containerPortrait": "ModelHeader-module__flUtYW__containerPortrait",
  "fadeInItems": "ModelHeader-module__flUtYW__fadeInItems",
  "img": "ModelHeader-module__flUtYW__img",
  "imgHalf": "ModelHeader-module__flUtYW__imgHalf",
  "imgHalfWrap": "ModelHeader-module__flUtYW__imgHalfWrap",
  "socialStats": "ModelHeader-module__flUtYW__socialStats",
  "spacing--lg": "ModelHeader-module__flUtYW__spacing--lg",
  "spacing--md": "ModelHeader-module__flUtYW__spacing--md",
  "spacing--sm": "ModelHeader-module__flUtYW__spacing--sm",
  "spacing--xl": "ModelHeader-module__flUtYW__spacing--xl",
  "spacing--xs": "ModelHeader-module__flUtYW__spacing--xs",
  "spacing--xxl": "ModelHeader-module__flUtYW__spacing--xxl",
  "spacing--xxs": "ModelHeader-module__flUtYW__spacing--xxs",
  "spacing--xxxl": "ModelHeader-module__flUtYW__spacing--xxxl",
  "spacing--xxxs": "ModelHeader-module__flUtYW__spacing--xxxs",
  "squareLayout": "ModelHeader-module__flUtYW__squareLayout",
  "text": "ModelHeader-module__flUtYW__text",
  "textHidden": "ModelHeader-module__flUtYW__textHidden",
  "textVisible": "ModelHeader-module__flUtYW__textVisible",
  "title": "ModelHeader-module__flUtYW__title",
});
